/**********************************************************
 * Templates
 **********************************************************/

export { main } from '../templates/main.js';
export { user } from '../templates/user.js';
export { schedule } from '../templates/schedule.js';
export { ranking } from '../templates/ranking.js';
export { board } from '../templates/board.js';
export { board32 } from '../templates/board32.js';
export { quickRanking } from '../templates/quickRanking.js';
export { history } from '../templates/history.js';
export { notes } from '../templates/notes.js';
export { login } from '../templates/login/login.js';
export { register } from '../templates/login/register.js';
export { bet } from '../templates/bet/bet.js';
export { liveMatch } from '../templates/liveMatch.js';
export { bestThirds } from '../templates/bestThirds.js';
